import { render, staticRenderFns } from "./ReadytoSend.vue?vue&type=template&id=fc844af4&"
import script from "./ReadytoSend.vue?vue&type=script&lang=ts&"
export * from "./ReadytoSend.vue?vue&type=script&lang=ts&"
import style0 from "./ReadytoSend.vue?vue&type=style&index=0&id=fc844af4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports